import classNames from "../../../utils/classNames"

export const TextInput = ({ label, register, registerName, disabled = false, richtext = false, rows = 2, cols = "sm:col-span-1", type = "text" }) => {

  return (
    <div className={cols}>
      <label className="text-sm font-medium text-gray-700">
        {label}
      </label>
      {
        richtext ?
          <textarea
            {...register(registerName)}
            disabled={disabled}
            rows={rows}
            className={classNames(disabled ? "bg-gray-300" : "", "w-full block mt-1 shadow-sm focus:ring-etpink-500 focus:border-etpink-500 sm:text-sm border-gray-300 rounded-md")}
          />
          :
          <input
            {...register(registerName)}
            disabled={disabled}
            type={type}
            className={classNames(disabled ? "bg-gray-300" : "", "w-full block mt-1 shadow-sm focus:ring-etpink-500 focus:border-etpink-500 sm:text-sm border-gray-300 rounded-md")}
          />
      }
    </div>
  )
}